export default "__VITE_ASSET__c5217e5b__"